import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import NavigationBar from "../../components/NavigationBar/NavigationBar";
import { GetprofileDriverStylingApi } from "../../store/profile/action";
import { Backdrop, CircularProgress, makeStyles } from "@material-ui/core";
import PreLoginNavigationBar from "../../components/NavigationBar/PreLoginNavigationBar";
import { getProfileData } from "../../store/profile/selector";

const useStyles = makeStyles({
  backdrop: {
    zIndex: 99999999999999999,
    color: "#fff",
    background: "#3f51b5",
  },
});
export default function Layout(props) {
  const { isPrelogin } = props;
  const dispatch = useDispatch();
  const classes = useStyles();
  const [StylingItem, setStylingItem] = useState("");
  const getStyling = useSelector(
    (state) => state.profileState.profileDriverSetStyling
  );
  // const responseData = useSelector(getProfileData)
  const [loginData, setLoginData] = useState(useSelector(getProfileData));
  const UserParams = useParams();

  useEffect(() => {
    setStylingItem(getStyling);
    document.title = StylingItem?.pageTitle || "Driver Portal";
    // document.title =  "Driver Portal\u00AE";

  }, [getStyling]);

  useEffect(() => {
    document.title = StylingItem?.pageTitle || "Driver Portal";
    // document.title =  "Driver Portal\u00AE";

  }, [StylingItem]);

  useEffect(() => {
    dispatch(GetprofileDriverStylingApi(UserParams.customer));
  }, [UserParams.customer]);

  // if (StylingItem === "") {
  //     return (
  //         <>
  //             <Backdrop className={classes.backdrop} open={true} >
  //                 <CircularProgress color="inherit" />
  //             </Backdrop>
  //         </>
  //     )
  // }
  return (
    <>
      <Header StylingItem={StylingItem} />
      {isPrelogin ? (
        <PreLoginNavigationBar StylingItem={StylingItem} isPrelogin={isPrelogin}/>
      ) : (
        <NavigationBar StylingItem={StylingItem} />
      )}
      {React.cloneElement(props.children, { StylingItem: StylingItem })}
      <Footer StylingItem={StylingItem} />
    </>
  );
}
Layout.defaultProps = {
  isPrelogin: false,
};
